<template>
  <div id="app">
    <div class="app" :class="{ 'app--hide': !showBackground }">
      <router-view/>
    </div>
    <portal-target name="loadingPage"></portal-target>
    <portal-target name="loadingLanguage"></portal-target>
    <portal-target class="modals" name="modals" :class="{ 'modals--hide': !showBackground }" multiple></portal-target>

    <confirm-modal></confirm-modal>

    <notify></notify>

    <div class="app_browser-qr-scanner"></div>

    <div class="app__barcode-actions-container pb-2" v-if="!showBackground">
      <v-button width="full" @click="nativeBarcodeScanStop()" color="error">{{ $t('components.Profile.addShop.close') }}</v-button>
    </div>
  </div>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal'
import Notify from '@/components/Notify'
import vButton from '@/ui/controls/vButton'

import handleGraphqlError, { refreshSession } from '@/mixins/handleGraphqlError'
import setLocale from '@/mixins/setLocale'
import reFetchOnAppVisible from '@/mixins/reFetchOnAppVisible'
import nativeBarcodeScan from '@/mixins/nativeBarcodeScan'

import { SplashScreen } from '@capacitor/splash-screen'

export default {
  components: {
    Notify,
    ConfirmModal,
    vButton
  },

  mixins: [handleGraphqlError, setLocale, reFetchOnAppVisible, nativeBarcodeScan, refreshSession],

  methods: {

  },

  created () {
    this.setLocale()
    document.body.addEventListener('touchmove', function (evt) {
      if (!evt._isScroller) {
        evt.preventDefault()
      }
    }, { passive: false })

    this.refreshSession()
  },

  mounted () {
    SplashScreen.hide()
  }
}
</script>

<style lang="scss">
  .app {
    transition: all .3s;

    &--hide {
      opacity: 0;
      visibility: hidden;
    }

    &__barcode-actions-container {
      position: absolute;
      width: 100%;
      padding-left: 2rem;
      padding-right: 2rem;
      z-index: 999;

      display: flex;

      @include iosBottom(2rem)
    }

/*    &--translate {
      transform: translateY(-2%);
      opacity: .5;
    }*/
  }

  .modals {
    transition: all .3s;

    &--hide {
      opacity: 0;
      visibility: hidden;
    }
  }
</style>
